import { ErrorHandler, inject, Injectable } from '@angular/core';
import { BannerMessage } from 'src/shared/banners/banner';
import { BannerService } from 'src/shared/banners/banner.service';
import { VersionService } from 'src/shared/version.service';

interface IncomingError {
  message?: string;
}

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  readonly #bannerService = inject(BannerService);
  readonly #versionService = inject(VersionService);

  async handleError(error: IncomingError): Promise<void> {
    if (error?.message?.includes('dynamically imported module')) {
      const message: BannerMessage = {
        content: await this.#versionService.isSameVersion()
          ? 'Something went wrong. Please try again.'
          : 'EZLynx has been updated! Please refresh to continue working',
        bannerType: 'warn',
        showRefreshButton: true,
        hideDismissButton: true,
      };
      this.#bannerService.addMessage(message);
    }
    super.handleError(error);
  }
}
